import styled from 'styled-components';

export const Dev = styled.div`
  position: relative;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
`;

export const Container = styled.div`
  padding: 20px;
  overflow-y: auto;
  height: 100%;

  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }
`;

export const Cards = styled.div`
  margin: 20px 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    width: 100%;
  }
`;

export const Block = styled.div`
  flex: 1 1 auto;
  background: #626ed4;
  border-radius: 4px;
  display: flex;
  padding: 20px;
  flex-direction: column;

  & + div {
    margin-left: 10px;
  }

  /* Responsivo */
  @media (max-width: 1200px) {
    width: 100%;
    margin-bottom: 10px;

    & + div {
      margin-left: 0;
    }
  }
`;

export const Dados = styled.div`
  display: flex;
`;

export const Icon = styled.div`
  padding: 10px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  margin-right: 15px;
`;

export const Info = styled.div`
  h4 {
    text-transform: uppercase;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.5);
  }

  span {
    display: block;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
  }
`;

export const Menu = styled.div`
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h4 {
    color: rgba(255, 255, 255, 0.9);
    font-weight: normal;
    font-size: 14px;
    font-family: 'Roboto', sans-serif;
  }

  button {
    background: none;
    border: 0;
  }
`;

export const Wrapper = styled.div`
  display: flex;

  /* Responsivo */
  @media (max-width: 1200px) {
    width: 100%;
    margin-bottom: 10px;
    display: block;

    & + div {
      margin-left: 0;
    }
  }
`;

export const Grafico = styled.div`
  margin-top: 20px;
`;

export const Alerta = styled.div`
  width: 100%;
  background: #e64949;
  padding: 10px;
  margin-bottom: 10px;
  border: 4px;
  text-align: center;

  span {
    color: #fff;
  }
`;
